module.exports = function() {
  return new Worker(__webpack_public_path__ + "35df611bdcfb00278635.worker.js");
};